import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../components/common';
import { isSafeRedirectUrl } from '../utils/redirectSafety';

function safeNext(raw) {
  if (!raw) return null;
  if (!isSafeRedirectUrl(raw)) return null;
  return raw;
}

export default function Logout() {
  const { logout } = useAuth();
  const location = useLocation();
  const toast = useToast();
  const [message, setMessage] = useState('Logging out…');

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search || '');
      const next = safeNext(params.get('next')) || '/login';

      try {
        // APP SCOPE, EXPLICITLY. `logout()` with no argument defaults to
        // scope='global' the whole way down (AuthContext, then auth.js), which
        // revokes EVERY session the person holds — every app, every device.
        //
        // This page is one app's sign-out. Ending every other app's session is
        // a different act, and the rail already offers it as its own door
        // (onSignOutEcosystem -> scope='global'); Layout.js spells out why the
        // two are kept apart. An app that binds a Paradigm session — Missions
        // does — treats losing it as a full sign-out and can only return
        // through the consent screen, so a global revoke from here reads as
        // "re-authorize everything" to somebody who meant to close a tab.
        await logout({ scope: 'app' });
      } catch (e) {
        // ignore; logout() already best-effort clears local state
      }

      toast.info('Logged out. Redirecting…');
      setMessage('Logged out. Redirecting…');
      window.location.replace(next);
    };

    run();
  }, [logout, location.search]);

  return (
    <div className="loading-screen">
      {message}
    </div>
  );
}


